import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4 2H20C20.6 2 21 2.4 21 3V21C21 21.6 20.6 22 20 22H4C3.4 22 3 21.6 3 21V3C3 2.4 3.4 2 4 2ZM19 4H5V6H19V4ZM5 8V20H19V8H5ZM7 14C7 11.2 9.2 9 12 9C14.8 9 17 11.2 17 14C17 16.8 14.8 19 12 19C9.2 19 7 16.8 7 14ZM9 14C9 15.7 10.3 17 12 17C13.7 17 15 15.7 15 14C15 12.3 13.7 11 12 11C10.3 11 9 12.3 9 14Z"
  />,
  'Conveniences'
)
